import { createContext } from 'react';

const PersonalInformationContext = createContext();

export default PersonalInformationContext;
